import fetchInterceptor, { FetchOptions } from "../../../utils/fetchInterceptor ";
import { addSubscriptionEndpoint as endpoint } from "../apiEndPoints";
import { IAddSubscription } from "../subscriptionType";

const AddSubscriptionAPI = async ({ 
  header, 

  planName, 
  monthlyAmount, 

  policyCount, 
  planDetails, 
  createdBy, 
  userLimit, 
  discount 
}: IAddSubscription) => {
  
  const url = endpoint();
  
  const options: FetchOptions = {
    method: "POST",
    headers: header,
    body: JSON.stringify({
      planName,
      monthlyAmount,

      policyCount,
      createdBy,

      planDetails,
      userLimit, // Ensuring userLimit is included
      discount    // Ensuring discount is included
    }),
  };

  return fetchInterceptor(url, options);
};

export default AddSubscriptionAPI;
